const NewDeleteIcon = ({ className = "", color = "#E46D64" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="XB8u_5gU"
      className={className}
    >
      <path
        d="M7.29175 14.584L10.0001 11.9358L12.7084 14.584L14.1667 13.1581L11.4584 10.5099L14.1667 7.86176L12.7084 6.43584L10.0001 9.08398L7.29175 6.43584L5.83342 7.86176L8.54175 10.5099L5.83342 13.1581L7.29175 14.584ZM4.79175 19.1673C4.21883 19.1673 3.72855 18.968 3.32091 18.5694C2.91258 18.1702 2.70841 17.6905 2.70841 17.1303V3.88954H1.66675V1.8525H6.87508V0.833984H13.1251V1.8525H18.3334V3.88954H17.2917V17.1303C17.2917 17.6905 17.0879 18.1702 16.6803 18.5694C16.272 18.968 15.7813 19.1673 15.2084 19.1673H4.79175ZM15.2084 3.88954H4.79175V17.1303H15.2084V3.88954Z"
        fill={color}
        test-id="5FuvKPLg"
      />
    </svg>
  );
};

export default NewDeleteIcon;
